import dynamic from 'next/dynamic';

const FooterSticky = dynamic(() => import('./FooterSticky'));

export default FooterSticky
